import { Task } from "../models/Kanban";
import { KanbanBoardStatus } from "../types";

export const getTasksByStatus = (tasks: Task[], status: KanbanBoardStatus) => {
  return tasks.filter((task) => task.status === status);
};

export const getTaskById = (tasks: Task[], id: string) => {
  return tasks.find((task) => task.id === id);
};
